import { render, staticRenderFns } from "./ZhYmp.vue?vue&type=template&id=efc0f462&scoped=true&"
import script from "./ZhYmp.vue?vue&type=script&lang=js&"
export * from "./ZhYmp.vue?vue&type=script&lang=js&"
import style0 from "./ZhYmp.vue?vue&type=style&index=0&id=efc0f462&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc0f462",
  null
  
)

export default component.exports